import { Menu, MenuItem, Tooltip } from '@mui/material';
import React from 'react';

function MoreActionsMenu({
	anchorEl,
	view,
	open,
	onClose,
	isFeedbackActionable,
	showCancelToolTip,
	onCancelClick,
	onResendClick,
	feedbackRequestId,
	t,
	classes,
}) {
	const cancelRequest = 'cancel request';

	let cancelMenuItem = null;
	if (!isFeedbackActionable || showCancelToolTip) {
		cancelMenuItem = (
			<Tooltip
				title={showCancelToolTip ? t('invalid_permission_to_cancel_feedback_tooltip_message') : ''}
				classes={{ tooltip: classes.tooltip }}
				aria-label={
					showCancelToolTip
						? `${t(cancelRequest)}, ${t('invalid_permission_to_cancel_feedback_tooltip_message')}`
						: ''
				}
				aria-disabled={!showCancelToolTip}
			>
				<span role="group">
					<MenuItem
						disabled
						aria-label={t(cancelRequest)}
						key={`cancel-feedback-${feedbackRequestId}`}
					>
						{t(cancelRequest)}
					</MenuItem>
				</span>
			</Tooltip>
		);
	} else {
		cancelMenuItem = (
			<MenuItem
				key={`cancel-feedback-${feedbackRequestId}`}
				aria-label={t(cancelRequest)}
				onClick={onCancelClick}
			>
				{t(cancelRequest)}
			</MenuItem>
		);
	}

	let resendMenuItem = null;
	if (view === 'feedbackTabView') {
		resendMenuItem = (
			<MenuItem
				key={`resend-request-${feedbackRequestId}`}
				aria-label={t('resend_request')}
				disabled={!isFeedbackActionable}
				onClick={isFeedbackActionable ? onResendClick : null}
			>
				{t('resend_request')}
			</MenuItem>
		);
	}

	return (
		<Menu
			anchorEl={anchorEl}
			onClose={onClose}
			open={open}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			slotProps={{
				paper: { sx: { ml: 6 } },
			}}
			sx={{
				'& .MuiPopover-paper.MuiMenu-paper': {
					border: '1px solid rgba(0, 0, 0, 0.54)',
				},
			}}
		>
			{cancelMenuItem}
			{resendMenuItem}
		</Menu>
	);
}

export default MoreActionsMenu;
